import { useEffect, useState } from 'react'
import { Form, FormInstance, Input, InputNumber, Radio } from 'antd'
import LocalizationKeys from '../../../i18n/LocalizationKeys'
import { useAppSelector } from '../../../store/hooks'
import i18n from '../../../i18n/setupLocalization'
import { numberRule, requiredRule, stringRule } from '../../../helpers/rules'
import TextArea from 'antd/es/input/TextArea'

interface Props {
  form: FormInstance
}

const Create = ({ form }: Props) => {
  const { isOpen: SBRMIsOpen } = useAppSelector((state) => state.SBRM)

  useEffect(() => {
    if (!SBRMIsOpen) {
      // We want to trigger only the reset
      // when the SBRM opens
      return
    }
    //
  }, [SBRMIsOpen])

  return <Form form={form} layout="vertical"></Form>
}

export default Create
